'use client'
import{a as e}from"./chunk-GQBBFCVQ.mjs";import{a as r}from"./chunk-S6W7AAND.mjs";import{jsx as i,jsxs as s}from"react/jsx-runtime";var c=({url:t,title:o,description:p})=>s("div",{className:"!ui-space-y-4",children:[i(r,{text:t}),i(e,{url:t,title:o,description:p})]});export{c as a};
